import React from "react";
import { Chip, Typography } from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";

const SUGGESTIONS = [
  "Oi, queria marcar uma consulta.",
  "Vocês aceitam convênio?",
  "Quanto custa e tem horário amanhã?",
  "Minha filha tem 3 meses e está com a cabecinha achatada, vocês atendem?",
];

/**
 * Estado inicial da conversa: orienta o usuário e oferece mensagens de exemplo
 * baseadas nos cenários de teste da feature.
 */
function SimulatorEmptyState({ onSuggestion, disabled }) {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <SmartToyOutlinedIcon style={{ fontSize: 48, color: "var(--color-blue-main, #5A80FB)" }} />
      <Typography variant="h6" style={{ color: "var(--color-text-dark, #2D3748)" }}>
        Converse como se você fosse o paciente
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ maxWidth: "480px" }}>
        A IA responderá como a secretária da sua clínica, usando as informações reais
        de profissionais, procedimentos, valores e formas de pagamento.
      </Typography>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center", maxWidth: "560px" }}>
        {SUGGESTIONS.map((suggestion) => (
          <Chip
            key={suggestion}
            label={suggestion}
            variant="outlined"
            disabled={disabled}
            onClick={() => onSuggestion(suggestion)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>
    </div>
  );
}

export default SimulatorEmptyState;
